import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seminar-hall',
  templateUrl: './seminar-hall.component.html',
  styleUrls: ['./seminar-hall.component.scss']
})
export class SeminarHallComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
